import React from "react";
import ClayModal, { useModal } from "@clayui/modal";
import ClayButton from "@clayui/button";
import {JsonEditor,githubDarkTheme} from "json-edit-react";

function TemplateDataModal({ show, onClose, templateJson, setTemplateJson, onSave }) {
    const { observer } = useModal({ onClose });

    if (!show) return null;

    return (
        <ClayModal observer={observer} size="lg">
            <ClayModal.Header>Edit Template</ClayModal.Header>
            <ClayModal.Body>
                <JsonEditor data={templateJson} setData={setTemplateJson} minWidth="100%" theme={githubDarkTheme} />
            </ClayModal.Body>
            <ClayModal.Footer
                last={
                    <ClayButton.Group spaced>
                        <ClayButton displayType="secondary" onClick={onClose}>
                            Cancel
                        </ClayButton>
                        <ClayButton displayType="primary" onClick={onSave}>
                            Save
                        </ClayButton>
                    </ClayButton.Group>
                }
            />
        </ClayModal>
    );
}

export default TemplateDataModal;